import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { CurrencyTypeInput } from "@/app/Common/Components/CurrencyTypeInput";
import { HireUnitRadioButton } from "@/app/Common/Components/HireUnitRadioButton";
import { SubmitButtonInput } from "@/lib/Components/Form/Inputs/SubmitButtonInput";
import { useGqlMutation, useOrgId } from "@/lib/GraphQLCodegen/fetcher";
import { createSupplierMutation } from "@/app/Suppliers/GraphQL/supplierMutations";
import { Currency } from "@/gql/graphql";
import { Heading } from "@/components/catalyst/heading";
import { Text } from "@/components/catalyst/text";
import { Formation } from "@/lib/Components/Form/Providers/Formation";
import { Form } from "formik";
import { useActiveOrganisation } from "@/app/Organisations/Hooks/useActiveOrganisation";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { createSupplierValidation } from "@/app/Onboarding/Validators/createSupplierValidation";

export function OnboardingCreateSupplierScreen() {
  // Org comes from the URL path param (the source of truth for this flow); the
  // fetcher reads the same param for the create-supplier header.
  // `useActiveOrganisation` resolves it to the org record for display.
  const orgId = useOrgId();
  const { activeOrganisation } = useActiveOrganisation();
  const { mutateAsync } = useGqlMutation(createSupplierMutation);

  return (
    <div className="flex w-full items-center justify-center">
      <div className="w-full max-w-xs space-y-4">
        <div>
          <Heading>Add your business</Heading>
          <Text className="mt-1">Add your business to start using Imoova</Text>
        </div>

        <Formation
          validationSchema={toFormikValidationSchema(createSupplierValidation)}
          initialValues={{
            name: "",
            currency: Currency.Usd,
            hire_unit_type: null!,
          }}
          onSubmit={async (values) => {
            const res = await mutateAsync({
              input: {
                name: values.name,
                currency: values.currency,
                hire_unit_type: values.hire_unit_type,
              },
            });

            window.location.href = `/org/${orgId}/supplier/${res.createSupplier.id}`;
          }}
        >
          <Form className="grid w-full grid-cols-1 gap-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Organisation
              </label>
              <input
                type="text"
                disabled
                value={activeOrganisation?.name ?? ""}
                className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-500"
              />
            </div>
            <TextInput name="name" label="Business name" />
            <CurrencyTypeInput name="currency" label="Currency" />
            <HireUnitRadioButton name="hire_unit_type" label="Units" />
            <SubmitButtonInput>Create</SubmitButtonInput>
          </Form>
        </Formation>
      </div>
    </div>
  );
}
